import React from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { cotizacion } from '../../data/data';
import { frecuenciaPagos, SAs } from '../../data/mochaData';
import { getText } from '../../data/texts';
import useCustomTarificarVSP from '../../hooks/useCustomTarificar';
import useOcupacion from '../../hooks/useOcupacion';
import createOportunity from '../../services/salesforce';
import { calculatePrima, getResumen } from '../../services/tarificar';
import { BannerStep1, ImgNext, ImgAlertOk } from '../../svg';
import { twoDecimal } from '../../utils/helpers';
import DivRow from '../controls/DivRow';
import Input from '../controls/Input';
import InputSelect from '../controls/InputSelect';
import Prima from '../poliza/Prima';
import Modal from 'react-modal';
import { customStyles, endPoints } from '../../utils/constanst';
import http from '../../services/http';

const Cotizacion = props => {

    const { loading: loadingPage } = props;

    const [canContinue, setCanContinue] = useState(false);
    const [page, setPage] = useState(0);
    const [data, setData] = useState({ ...cotizacion });
    const { ocupacions } = useOcupacion({ loading: loadingPage });

    const [showReadyDialog, setShowReadyDialog] = useState(false);

    const { tarifas, loading } = useCustomTarificarVSP({ edad: `${data.edad}`, 'catactiv': data.catactiv, suma: data.sa });

    const handleChange = (e) => setData({ ...data, [e.target.name]: e.target.value });

    const handleChangeOcupacion = (e) => {

        const ocupacion = ocupacions.find(o => o.value === e.target.value);

        setData({ ...data, ocupacion: ocupacion.value, catactiv: ocupacion.description });

    }

    useEffect(() => {

        const prevState = props?.location?.state;

        if (prevState && prevState.data) {

            const { nombres, apellidos, email, telefonoCelular, sa, frecuenciaPagos, ocupacion, prima, primeraCuota, catactiv, aceptTerminos, edad, pageIndex } = prevState.data;

            console.log(pageIndex);

            setData({
                ...data,
                nombres,
                apellidos,
                email,
                telefono: telefonoCelular,
                sa,
                frecuenciaPagos,
                ocupacion,
                catactiv,
                prima,
                cuota: primeraCuota,
                aceptTerminos,
                edad,
                pageIndex
            });

            setPage(pageIndex);
        }

    }, [0]);

    useEffect(() => {

        if (tarifas != null) {

            const prima = getResumen(tarifas);

            const primaCalutated = calculatePrima(prima);

            const _prima = primaCalutated(data.frecuenciaPagos);

            setData(current => ({
                ...current,
                prima: twoDecimal(prima),
                cuota: twoDecimal(_prima)
            }));
            setCanContinue(true);

        }

    }, [tarifas, data.frecuenciaPagos, data.ocupacion]);

    const handleSubmit = async (e) => {

        let result = document.querySelector('form').reportValidity();

        if (result) {
            setPage(1);
            sendOportunity();
        }


    }

    const continuar = () => {
        let result = document.querySelector('form').reportValidity();

        if (!result) return;

        //Mostrar dialogo
        setShowReadyDialog(true);
    }

    const continuePage = () => {

        setShowReadyDialog(false);

        props.history.push('/continue', { data: { ...data, pageIndex: page } });
    }

    const contactarme = () => {
        setShowReadyDialog(false);
        http(endPoints.contactameVSP).post({
            "nombre": data.nombres,
            "apellido":data.apellidos,
            "celular": data.telefono,
            "nombres": data.nombres+' '+data.apellidos,
            "email": data.email,
            "oportunidad":data.oportunidad
        });
        window.location.href = '/ProductosDigitales';
    }

    const sendOportunity = () => {
        let searchParams = new URLSearchParams(window.location.search);
        let src = searchParams.get('source');
        data["source"] = src;

        createOportunity({
            "nombres": `${data.nombres} ${data.apellidos}`,
            "celular": data.telefono,
            "source": src,
            "suma": data.sa,
            //"prima": data.prima,
            "email": data.email,
            //"catactiv": data.ocupacion,
            "edad": data.edad,
        }).then(data=>{
            setData(prev=>({
                ...prev,
                oportunidad:data.oportunidad
            }));
       
        });
    }

    return (
        <div>
            <form action="" className="w750">
                <h1 className="txt-muted txt-center">¡Calculá tu seguro ahora!</h1>
                <h2 className="txt-muted txt-center">Compartinos tus datos y cotizá tu Vida Segura Plus</h2>
                {page === 0 &&
                    <div>
                        <div className="reponsive">
                            <div className="reponsive-width-6">
                                <div className="p10">
                                    <BannerStep1 />
                                </div>
                            </div>
                            <div className="reponsive-width-6">
                                <div className="p10">
                                    <Input placeholder='Nombre' label='Nombre' field='nombres' value={data.nombres} onChange={handleChange} />
                                    <Input placeholder='Apellidos' label='Apellidos' field='apellidos' value={data.apellidos} onChange={handleChange} />
                                    <Input placeholder='Correo electrónico' label='Correo electrónico' type='email' field='email' value={data.email} onChange={handleChange} />
                                    <Input label='Número Celular' pattern='\d\d\d\d-\d\d\d\d' title='Teléfono inválido' type='maskInput' mask='9999-9999' field='telefono' placeholder='0000-0000' value={data.telefono} onChange={handleChange} />
                                    <Input placeholder='Edad' label='Edad' type='number' field='edad' value={data.edad} onChange={handleChange} />
                                    <div>
                                        <input checked={data.aceptTerminos} type="checkbox" name="" id="teminosycondiciones" onChange={e => setData({ ...data, aceptTerminos: e.target.checked })} required />
                                        <label htmlFor="teminosycondiciones">Acepto los términos y condiciones</label>
                                    </div>
                                    <div className="text-right">
                                        <a rel='noreferrer' href="https://www.lafise.com/terminos-y-condiciones-de-uso" target='_blank' className="btn-primary">Ver terminos y condiciones</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="reponsive align-r">
                            <DivRow width='100%'>
                                <button className="control-button-btn btn-next"
                                    type="button"
                                    onClick={handleSubmit}
                                >Siguiente <ImgNext /></button>
                            </DivRow>
                        </div>
                    </div>
                }
                {
                    page === 1 &&
                    <div>
                        <div className="reponsive">
                            <div className="reponsive-width-6">
                                <div className="p10">
                                    <InputSelect field='sa' label='Suma Asegurada' value={data.sa} onChange={handleChange} dataProvider={SAs} />
                                    <InputSelect label='Ocupación' field='ocupacion' value={data.ocupacion} dataProvider={ocupacions} onChange={handleChangeOcupacion} />
                                    <InputSelect label='Frecuencia de pago' field='frecuenciaPagos' value={data.frecuenciaPagos} dataProvider={frecuenciaPagos} onChange={handleChange} />
                                </div>
                            </div>
                            <div className="reponsive-width-6">
                                <div className="p10">
                                    <div className="box txt-center">
                                        <h2 className="txt-muted">{getText(data.frecuenciaPagos)}</h2>
                                        <div className='h80'>
                                            {
                                                loading
                                                    ? <h2 className='data-loading'>Calculando...</h2>
                                                    : <Prima data={data} />
                                            }
                                        </div>
                                        <p className="txt-muted">
                                            *El precio de la prima es calculado sobre las coberturas básicas del seguro. Estas condiciones pueden variar de acuerdo a los datos declarados en la compra del seguro. La cobertura opcional de moto tiene un cargo adicional.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="align-r">
                            <DivRow width='100%'>
                                <button className="control-button-btn btn-next"
                                    disabled={!canContinue}
                                    type="button"
                                    onClick={continuar}
                                >Continuar <ImgNext /></button>
                            </DivRow>
                        </div>
                    </div>
                }

            </form>
            <Modal
                isOpen={showReadyDialog}
                onRequestClose={() => setShowReadyDialog(false)}
                style={customStyles}
                shouldCloseOnOverlayClick={false}
                contentLabel="Example Modal"
            >
                <div className="dialog-center-content">
                    <h2 className="txt-primary">¡Su cotización esta lista!</h2>

                </div>

                <div className="dialog-center-content">
                    <ImgAlertOk />
                </div>
                <div className="dialog-center-content">
                    <p >Has completado el formulario de cotización. Hacé clic en <b>"Continuar”</b>, para finalizar la compra de tu póliza, vas a necesitar:</p>
                </div>
                <div>
                    <ul>
                        <li><p>Fotografías de identificación (Frontal/trasera)</p></li>
                        <li><p>Tarjeta débito / crédito</p></li>
                    </ul>
                </div>
                <div className='dialog-center-content'>
                    <p>Si no deseas continuar hacé clic en <b>"Contáctenme"</b> y un ejecutivo de Seguros LAFISE se comunicará con vos lo antes posible.</p>
                </div>



                <div className="step">
                    <DivRow width="50%">
                        <div className="dialog-center-content">
                            <button type="button" className="control-button-btn btn-color-primary" onClick={contactarme} >Contáctenme</button>
                        </div>
                    </DivRow>
                    <DivRow width="50%">
                        <div className="dialog-center-content">
                            <button type="button" className="control-button-btn btn-color-primary" onClick={continuePage}>Continuar</button>
                        </div>
                    </DivRow>
                </div>

            </Modal>
        </div>
    );
}

export default Cotizacion;
